import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { reassignmentApi } from './reassignment.api';
import type { AgentWithLoad, ReassignInput, ReassignResult } from '@/types/api';
import { LIVE_STATUS_KEY } from '../admin/useLiveStatus';

export const AGENTS_KEY = ['admin', 'agents'] as const;

export function useAgents() {
  return useQuery<AgentWithLoad[]>({
    queryKey: AGENTS_KEY,
    queryFn: reassignmentApi.agents,
    staleTime: 10_000,
  });
}

export function useReassign() {
  const qc = useQueryClient();
  return useMutation<ReassignResult, Error, ReassignInput>({
    mutationFn: reassignmentApi.reassign,
    onSuccess: () => {
      // Refresh both agents-with-load and live monitoring snapshots.
      void qc.invalidateQueries({ queryKey: AGENTS_KEY });
      void qc.invalidateQueries({ queryKey: LIVE_STATUS_KEY });
    },
  });
}
